import React from 'react'
import Events from '../feature/Events/Events'
const EventsPage = () => {
  return <Events/>
}

export default EventsPage